import React from "react";
import Moment from "react-moment";
import { Box, Grid, Typography } from "@mui/material";

interface Props {
  field: string;
  value: any;
  isDateField?: boolean;
  fullwidth?: boolean;
}

const LABEL_MIN_WIDTH = 140;

export const CardItem = ({ field, value, isDateField = false, fullwidth = false }: Props) => {
  return (
    <Grid container item direction="row" xs={fullwidth ? 12 : 6}>
      <Grid item sx={{ minWidth: LABEL_MIN_WIDTH, flexShrink: 0 }}>
        <Box color="text.secondary">
          <Typography>{`${field}: `}</Typography>
        </Box>
      </Grid>
      <Grid item sx={{ flex: 1, minWidth: 0 }}>
        <Box color="text.primary" sx={{ ml: 1.5 }}>
          {isDateField ? (
            <Typography>
              <Moment local={true} format="MM/DD/YYYY hh:mm A" date={value} />
            </Typography>
          ) : (
            <Typography>{value}</Typography>
          )}
        </Box>
      </Grid>
    </Grid>
  );
};
